import { View } from "@react-pdf/renderer";
import { tableStyles } from "./SmartTitanProjektPDF";
import { DataTableHeaderGroup } from "./DataTableHeaderGroup";
import { DataTableFooterGroup } from "./DataTableFooterGroup";
import { DataTableDataRowGroup } from "./DataTableDataRowGroup";

export function DataTableGroup({ item, tableInput, tableCalculated, sumRsdi, lreq }) {
  return (
    <View style={tableStyles.tableContainer}>
      {/* TableHeader */}

      <DataTableHeaderGroup item={item} />

      {tableInput.map((row, index) => {
        return (
          <DataTableDataRowGroup
            item={item}
            key={index}
            index={index}
            tableInput={tableInput}
            tableCalculated={tableCalculated}
          />
        );
      })}

      {/* Table footer */}
      <DataTableFooterGroup item={item} sumRsdi={sumRsdi} lreq={lreq} />
    </View>
  );
}
